import FiltroHoteles from "@/assets/js/class/FiltroHoteles.js"
const state = {
  hotelesFiltrados: { hoteles: [], sinDispo: [] },
  todos: [],
  descripciones: [],
  isFiltrando: false,
  rq: null,
  filtros: null
}
const getters = {
  getHotelesFiltrados: state => {
    return Object.freeze(state.hotelesFiltrados)
  },
  isFiltrando: state => {
    return state.isFiltrando
  },
  getRq: state => {
    return state.rq
  },
  getFiltros: state => {
    return state.filtros
  },
  getDescripciones: state => {
    return state.descripciones
  }
}
const actions = {
  guardarTodosHoteles({ commit }, item) {
    commit("setTodos", item.todos)
    commit("setRq", item.rq)
    commit("setDescripciones", item.descripciones)
  },
  filtrar({ commit, state }, item) {
    commit("setHotelesFiltrados", [])
    var filtro = new FiltroHoteles(item, state.todos)
    var filtrados = filtro.getFiltrados()
    commit("setHotelesFiltrados", filtrados)
  },
  setFiltrando({ commit }, item) {
    commit("setFiltrando", item)
  },
  setFiltros({ commit }, item) {
    commit("mutFiltro", item)
  }
}
const mutations = {
  setTodos(state, rs) {
    state.todos = rs
  },
  setHotelesFiltrados(state, filtrados) {
    state.hotelesFiltrados = filtrados
  },
  setFiltrando(state, valor) {
    state.isFiltrando = valor
  },
  setRq(state, rq) {
    state.rq = rq
  },
  mutFiltro(state, item) {
    state.filtros = item
  },
  setDescripciones(state, item) {
    state.descripciones = item
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
